import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import classes from "./maintainerStyles.module.scss"
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
//import "ace-builds/src-noconflict/ace";
import { OrgIdContext } from "../../store/orgId_context";
import { useContext, useEffect, useRef, useState } from 'react';
import { JsonEditor as Editor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";
import { JSONSchemaFaker } from "json-schema-faker";
import { ThreeDots } from 'react-loader-spinner';

const SessionJsonModalPopup = ({onHide, sessionJson, ...props}) =>{
    const [loader, setLoader] = useState(true);
    const { sessionInfo } = useContext(OrgIdContext);
    const editorRef = useRef(null);
    
    useEffect(() => {
      setLoader(false);
      if(editorRef.current !== null)
        editorRef.current.set(sessionJson);
    }, [sessionJson])

    const setRef = (instance) => {
      if (instance) {
        editorRef.current = instance.jsonEditor;
      } else {
        editorRef.current = null;
      }
    };

    const onHideClick = () =>{
      setLoader(true);
      if(editorRef.current !== null)
        editorRef.current.set({"State" : "fetching new"});
      onHide();
    }
    return (
        <>
        <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className={classes.modalHeader}>
        <div className='w-100 d-flex '>
            <div>
              <PersonAddIcon style={{fontSize:"2.2rem", marginRight:"1rem"}}/>
              <span className={classes.modalTitleText}>Session json</span>
            </div>
            <div className="ms-auto">
              <HighlightOffIcon style={{fontSize:"2rem", cursor:"pointer"}} onClick={onHideClick}/>
            </div>
          </div>
      </Modal.Header>
      <Modal.Body className={classes.modalBody} style={{height:"80vh"}}>
        {loader && <ThreeDots wrapperStyle={{justifyContent:"center", height:"fit-content"}}/>}
        <Editor
          ref={setRef}
          mode="tree"
          allowedModes={["tree"]}
          //value={sessionJson}
          // ajv={ajv}
          //schema={schema}
          //editorOptions={customEditorOptions}
          // ace={ace}
        />
      </Modal.Body>
    </Modal>
        </>
    )
}

export default SessionJsonModalPopup;